import { Form, FormField, FormItem } from '@/components/ui-kit/form';
import { UseFormReturn } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { AgentBehaviorSettingsForm } from '../utils';
import { SliderControl } from '../slider-control';

type ModelParametersModalProps = {
  form: UseFormReturn<AgentBehaviorSettingsForm>;
  onClose: () => void;
  isMobile?: boolean;
};

export const ModelParametersModal = ({
  form,
  onClose,
  isMobile = false,
}: ModelParametersModalProps) => {
  const { t } = useTranslation();
  return (
    <>
      <div className="fixed inset-0 z-[100]" onClick={onClose} />

      <div
        className="fixed z-[101] overflow-hidden rounded-lg border bg-card shadow-lg"
        style={(() => {
          const element = document.getElementById('model-parameters-buttons');
          if (element) {
            const rect = element.getBoundingClientRect();
            return {
              left: `${rect.left}px`,
              top: `${rect.bottom + 8}px`,
              width: `${rect.width}px`,
            };
          }
          return {};
        })()}
      >
        <div className="max-h-[70vh] overflow-y-auto">
          <div className="p-6">
            <h3 className="mb-6 text-lg font-semibold">{t('MODEL_PARAMETERS')}</h3>

            <Form {...form}>
              <div className="space-y-8">
                <FormField
                  control={form.control}
                  name="llm_config.temperature"
                  render={({ field }) => (
                    <FormItem>
                      <SliderControl
                        label={t('TEMPERATURE')}
                        tooltipContent={t('TEMPERATURE_TOOLTIP')}
                        value={Math.min(field.value ?? 0.7, 1)}
                        onChange={field.onChange}
                        min={0}
                        max={1}
                        step={0.01}
                        // showSwitch
                        // switchChecked={true}
                        // switchDisabled
                        isMobile={isMobile}
                      />
                    </FormItem>
                  )}
                />

                <FormField
                  control={form.control}
                  name="llm_config.max_tokens"
                  render={({ field }) => (
                    <FormItem>
                      <SliderControl
                        label={t('MAXIMUM_RESPONSE')}
                        tooltipContent={t('MAXIMUM_RESPONSE_TOOLTIP')}
                        value={Math.min(field.value ?? 10000, 10000)}
                        onChange={field.onChange}
                        min={2}
                        max={10000}
                        step={1}
                        isMobile={isMobile}
                      />
                    </FormItem>
                  )}
                />
              </div>
            </Form>
          </div>
        </div>
      </div>
    </>
  );
};
